import classNames from 'classnames';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import { type Event, type Info } from '../types/event.types';
import { constructAlarmEventURL, constructEventURL } from '../utils/helperFunctions';
import styles from './Button.module.sass';

interface ButtonProps {
  event: Event | null;
  info?: Info | null;
  eventUrl?: string;
  alarmPage?: boolean;
  sharePage?: boolean;
  status?: 'OPEN' | 'CLOSED';
  tokenExpired?: boolean;
  buttonClass?: string;
}

const Button: React.FC<ButtonProps> = ({
  event,
  info,
  eventUrl,
  alarmPage,
  sharePage,
  tokenExpired,
  status,
  buttonClass,
}) => {
  const locale = useLocale();
  /* If event is falsy render an empty div */
  if (!event) {
    return <div />;
  }
  const buttonWrapperClass = classNames(styles['button-wrapper'], buttonClass, {
    [styles['open-alarm']]: status === 'OPEN' && !tokenExpired,
  });

  let link = '';

  if (alarmPage && eventUrl) {
    link = constructAlarmEventURL(eventUrl);
  } else if (sharePage && event && info) {
    link = constructEventURL(event, info);
  }

  return (
    <div className={buttonWrapperClass}>
      <a className={styles.link} href={link} data-testid="link">
        <div className={styles.item}>
          {sharePage && <span>{locale.spa.openInApp.toUpperCase()}</span>}
          {alarmPage && (
            <span>
              {status !== 'OPEN' || tokenExpired
                ? locale.spa.openInApp.toUpperCase()
                : locale.spa.manageAlarm.toUpperCase()}
            </span>
          )}
        </div>
      </a>
    </div>
  );
};

export default Button;
